import { render, staticRenderFns } from "./AddBigClass.vue?vue&type=template&id=50d37964&scoped=true"
import script from "./AddBigClass.vue?vue&type=script&lang=js"
export * from "./AddBigClass.vue?vue&type=script&lang=js"
import style0 from "./AddBigClass.vue?vue&type=style&index=0&id=50d37964&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d37964",
  null
  
)

export default component.exports